module.exports = "/arrow-downe4a4e26a1e1126bbbb3e85fa9ddd2afa.svg";